import request from '@/utils/request'

//Login
export function getPCPRetailersForRepositioning(page) {
  return request({ url: 'vpcpretailersrepositionlist', method: 'post', data: {'page': page} })
} 

export function getPCPMonitoringDetails() {
  return request({ url: 'vgetpcpmonitoringdetails', method: 'post', data: {'x': 'x'} })
} 

export function ignorePCPMilestone() {
  return request({ url: 'vignorepcpmilestone', method: 'post', data: {'x': 'x'} })
} 

export function getPCPAcountDetails() {
  return request({ url: 'vgetpcpaccountdetails', method: 'post', data: {'x': 'x'} })
} 

export function upgradePCPAccount(upgradePackage) {
  return request({ url: 'vupgradepcpaccount', method: 'post', data: {'upgradePackage': upgradePackage} })
} 


export function processPCPRetailerRepositioning(params) {
  return request({ url: 'vproceedpcpretailersreposition', method: 'post', data: params})
} 


export function getAvailablePCPForRepositionCount() {
  return request({ url: 'vgetpcprepositioncount', method: 'post',  data: {'x': 'x'} })
} 